import styles from './Layout.module.scss';

const Layout = ({ children }) => {
	return <div className={styles.page__container}>{children}</div>;
};

export default Layout;
